/* eslint-disable @typescript-eslint/no-use-before-define */
import { Icon } from 'lego-on-react';
import block from 'propmods';
import React from 'react';
import { useToggle } from 'react-use';

import * as keyset from 'i18n/DraftControlPanel';
import i18n from '@yandex-int/i18n';
import {
    SmartHomeValidationStatuses,
    SMART_HOME_VALIDATION_TYPES,
    SmartHomeValidationResponse,
    SmartHomeValidationType,
} from '../../model/draft';
import { Collapsible } from '../Animated/Collapsible';
import { Hint } from '../Hint/Hint';

import './ValidationStatuses.scss';

const b = block('ValidationStatuses');
const t = i18n(keyset);

const SslCheckMessage = () => {
    return (
        <span>
            {t('validation-ssl')}
            <Hint hint={t('validation-ssl-hint')} />
        </span>
    );
};

const SmartHomeValidationTypeText: Record<SmartHomeValidationType, string> = {
    availability: t('validation-availability'),
    user_unlink: t('validation-user_unlink'),
    devices: t('validation-devices'),
    devices_action: t('validation-devices_action'),
    devices_query: t('validation-devices_query'),
};

export const SmartHomeValidationStatusText: Record<SmartHomeValidationResponse['status'], React.ReactNode> = {
    OK: '',
    TIMEOUT: t('validation-timeout'),
    NOT_FOUND: t('validation-not_found'),
    PROVIDER_INTERNAL_ERROR: t('validation-internal-error'),
    SSL_CHECK_FAILED: <SslCheckMessage />,
};

type ValidationStatusItemProps = {
    validationType: SmartHomeValidationType;
    response: SmartHomeValidationResponse;
    url: string;
};
export const ValidationStatusesItem = ({
    response: { http_code, http_method, status },
    validationType,
    url,
}: ValidationStatusItemProps) => {
    const [opened, toggle] = useToggle(false);
    return (
        <div {...b('item')}>
            <div {...b('toggle')} onClick={toggle}>
                <Icon glyph="type-arrow" direction={opened ? 'top' : 'bottom'} />
            </div>
            <div {...b('item-headline')}>{t('validation-status')}</div>
            <div {...b('item-value')}>{SmartHomeValidationTypeText[validationType]}</div>
            <Collapsible visible={opened}>
                <div {...b('cut')}>
                    <div {...b('item-headline')}>{t('validation-error_type')}</div>
                    <div {...b('item-value')}>{SmartHomeValidationStatusText[status]}</div>
                    <div {...b('item-headline')}>URL</div>
                    <div {...b('item-value')}>{url}</div>
                    <div {...b('item-headline')}>{t('validation-method')}</div>
                    <div {...b('item-value')}>{http_method}</div>
                    <div {...b('item-headline')}>{t('validation-code')}</div>
                    <div {...b('item-value')}>{http_code || <span>&mdash;</span>}</div>
                </div>
            </Collapsible>
        </div>
    );
};

type ValidationStatusesProps = {
    statuses: SmartHomeValidationStatuses;
};
export const ValidationStatuses = ({ statuses }: ValidationStatusesProps) => {
    return (
        <div {...b()}>
            {SMART_HOME_VALIDATION_TYPES.map(
                (k) =>
                    statuses[k] &&
                    statuses[k].status !== 'OK' && (
                        <ValidationStatusesItem
                            key={String(k)}
                            url={statuses[k].url}
                            validationType={k}
                            response={statuses[k]}
                        />
                    ),
            )}
        </div>
    );
};
